import {
  EDI_FILTER_MARKET_DATA_FAILURE,
  EDI_FILTER_MARKET_DATA_LOADING,
  EDI_FILTER_MARKET_DATA_REQUEST,
  EDI_FILTER_MARKET_DATA_SUCCESS,
  EDI_FILTER_NPI_DATA_FAILURE,
  EDI_FILTER_NPI_DATA_LOADING,
  EDI_FILTER_NPI_DATA_REQUEST,
  EDI_FILTER_NPI_DATA_SUCCESS,
  EDI_FILTER_STATE_DATA_FAILURE,
  EDI_FILTER_STATE_DATA_LOADING,
  EDI_FILTER_STATE_DATA_REQUEST,
  EDI_FILTER_STATE_DATA_SUCCESS,
  EDI_FILTER_TIN_DATA_FAILURE,
  EDI_FILTER_TIN_DATA_LOADING,
  EDI_FILTER_TIN_DATA_REQUEST,
  EDI_FILTER_TIN_DATA_SUCCESS,
} from '../../actionTypes';

export const fetchEdiFilterNpiRequest = (payload: any, showGeoSegView: boolean = false, isHighVolumeTinFlow: boolean = false) => ({
  type: EDI_FILTER_NPI_DATA_REQUEST,
  payload: { ...payload, showGeoSegView, isHighVolumeTinFlow },
});

export const fetchEdiFilterNpiSuccess = (payload: any) => ({
  type: EDI_FILTER_NPI_DATA_SUCCESS,
  payload,
});

export const fetchEdiFilterNpiError = (payload: any) => ({
  type: EDI_FILTER_NPI_DATA_FAILURE,
  payload,
});

export const fetchEdiFilterNpiLoading = (payload: any) => ({
  type: EDI_FILTER_NPI_DATA_LOADING,
  payload,
});

export const fetchEdiFilterStateRequest = (payload: any) => ({
  type: EDI_FILTER_STATE_DATA_REQUEST,
  payload,
});

export const fetchEdiFilterStateSuccess = (payload: any) => ({
  type: EDI_FILTER_STATE_DATA_SUCCESS,
  payload,
});

export const fetchEdiFilterStateError = (payload: any) => ({
  type: EDI_FILTER_STATE_DATA_FAILURE,
  payload,
});

export const fetchEdiFilterStateLoading = (payload: any) => ({
  type: EDI_FILTER_STATE_DATA_LOADING,
  payload,
});

export const fetchEdiFilterMarketRequest = (payload: any) => ({
  type: EDI_FILTER_MARKET_DATA_REQUEST,
  payload,
});

export const fetchEdiFilterMarketSuccess = (payload: any) => ({
  type: EDI_FILTER_MARKET_DATA_SUCCESS,
  payload,
});

export const fetchEdiFilterMarketError = (payload: any) => ({
  type: EDI_FILTER_MARKET_DATA_FAILURE,
  payload,
});

export const fetchEdiFilterMarketLoading = (payload: any) => ({
  type: EDI_FILTER_MARKET_DATA_LOADING,
  payload,
});

export const fetchEdiFilterTinRequest = (payload: any, showGeoSegView: boolean = false, isHighVolumeTinFlow: boolean = false) => ({
  type: EDI_FILTER_TIN_DATA_REQUEST,
  payload: { ...payload, showGeoSegView, isHighVolumeTinFlow },
});

export const fetchEdiFilterTinSuccess = (payload: any) => ({
  type: EDI_FILTER_TIN_DATA_SUCCESS,
  payload,
});

export const fetchEdiFilterTinError = (payload: any) => ({
  type: EDI_FILTER_TIN_DATA_FAILURE,
  payload,
});

export const fetchEdiFilterTinLoading = (payload: any) => ({
  type: EDI_FILTER_TIN_DATA_LOADING,
  payload,
});
